import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { AuthProvider } from './components/AuthContext'
import Navbar from "./components/Navbar"
import Login from "./components/Login"
// import Reset from "./components/Reset"
import Reset from "./components/ResetByEmail"
import Registrasi from "./components/registrasi/View"
import RegistrasiPerorangan from "./components/registrasi/Perorangan"
import RegistrasiBadan from "./components/registrasi/Badan"
import Aktivasi from "./components/Aktivasi"
import Akun from "./components/akun/Main"
import Beranda from "./components/beranda/Main"
import Investasi from "./components/investasi/Main"
import KegiatanUsaha from "./components/kegiatan-usaha/Main"
import KegiatanUsahaDetail from "./components/kegiatan-usaha/Detail"
import CsrKatalog from "./components/csr-katalog/Main"
import CsrKatalogDetail from "./components/csr-katalog/Detail"
import Promosi from "./components/promosi/Main"
import PromosiDetail from "./components/promosi/Detail"
import Pengadaan from "./components/pengadaan/Main"
import PengadaanDetail from "./components/pengadaan/Detail"
import Laporan from "./components/laporan/Main"
import Dukungan from "./components/dukungan/Main"
import Produk from "./components/dukungan/peraturan/Produk"
import Pelayanan from "./components/dukungan/pelayanan/Title"
import Pengaduan from "./components/dukungan/pengaduan/Title"
import Info from "./components/info/Main"
import InfoDetail from "./components/info/Detail"
import Tentang from "./components/tentang/Main"
import Pejabat from "./components/tentang/Detail"
import Ketentuan from "./components/Ketentuan"
import Privasi from "./components/Privasi"
import Sitemap from "./components/Sitemap"
import Pencarian from "./components/pencarian/Main"
import Skm from "./components/skm/Main"
import Footbar from "./components/Footbar"
import Footer from "./components/Footer"
import { UnderConstruction } from "./components/UnderConstruction"

function App() {
  // useEffect(() => {
  //   // 1. Blokir Klik Kanan
  //   const handleContextMenu = (e) => e.preventDefault()
  //   document.addEventListener('contextmenu', handleContextMenu)

  //   // 2. Blokir Tombol Keyboard (Versi Super Ketat untuk Mac & Windows)
  //   const handleKeyDown = (e) => {
  //     const keyCode = e.keyCode || e.which

  //     // F12 (123)
  //     // Ctrl+Shift+I / Cmd+Opt+I (keyCode 73 untuk 'I')
  //     // Ctrl+Shift+J / Cmd+Opt+J (keyCode 74 untuk 'J')
  //     // Ctrl+Shift+C (keyCode 67 untuk 'C')
  //     // Ctrl+U / Cmd+U (keyCode 85 untuk 'U')
  //     if (
  //       keyCode === 123 ||
  //       ((e.ctrlKey || e.metaKey) && e.shiftKey && (keyCode === 73 || keyCode === 74 || keyCode === 67)) ||
  //       ((e.ctrlKey || e.metaKey) && keyCode === 85) ||
  //       (e.metaKey && e.altKey && keyCode === 73) // Khusus Mac tegar
  //     ) {
  //       e.preventDefault()
  //       return false
  //     }
  //   }
  //   document.addEventListener('keydown', handleKeyDown)

  //   // 3. Taktik Sadis: Spam Console Clear & Debugger
  //   // Kalau DevTools berhasil dibuka lewat menu atas browser, script ini bikin Consolenya blank & freeze
  //   const hackerBreaker = setInterval(() => {
  //     console.clear()
  //     // Trik evaluasi regex buat nge-trigger debugger pas DevTools aktif
  //     const devtools = /./
  //     devtools.toString = function () {
  //       eval("debugger")
  //     }
  //     console.log('%c', devtools)
  //   }, 100)

  //   // Cleanup
  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu)
  //     document.removeEventListener('keydown', handleKeyDown)
  //     clearInterval(hackerBreaker)
  //   }
  // }, [])

  const CommonLayout = ({ children }) => (
    <>
      <Navbar />
      {children}
      <Footbar />
      <Footer />
    </>
  )
  return (
    <AuthProvider>
      <BrowserRouter>
      {/* <BrowserRouter basename="/dev"> */}
        <div className="ms-site-container">
          <Routes>
            <Route path="/" element={<><CommonLayout><Beranda /></CommonLayout> </>}></Route>
            <Route path="/login" element={<><Login /> </>}></Route>
            <Route path="/reset" element={<><Reset /> </>}></Route>
            <Route path="register" element={<Registrasi />}></Route>
            <Route path="registrasi-perorangan" element={<RegistrasiPerorangan />}></Route>
            <Route path="registrasi-badan-usaha" element={<RegistrasiBadan />}></Route>
            <Route path="aktivasi-akun/:key/:code" element={<><Aktivasi /></>}></Route>
            <Route path="/akun/:kategori" element={<><CommonLayout><Akun /></CommonLayout> </>}></Route>
            <Route path="/akun/:kategori/:requestCode" element={<><CommonLayout><Akun /></CommonLayout> </>}></Route>
            <Route path="/mengapa-kota-bekasi/:kategori" element={<><CommonLayout><Investasi /></CommonLayout> </>}></Route>
            <Route path="/kegiatan-usaha/:kategori" element={<><CommonLayout><KegiatanUsaha /></CommonLayout> </>}></Route>
            <Route path="/kegiatan-usaha/:kategori/:code" element={<><CommonLayout><KegiatanUsahaDetail /></CommonLayout> </>}></Route>
            <Route path="/csr-katalog/:kluster" element={<><CommonLayout><CsrKatalog /></CommonLayout> </>}></Route>
            <Route path="/csr-katalog/:kluster/:code" element={<><CommonLayout><CsrKatalogDetail /></CommonLayout> </>}></Route>
            <Route path="/laporan/:kategori" element={<><CommonLayout><Laporan /></CommonLayout> </>}></Route>
            <Route path="/promosi" element={<><CommonLayout><Promosi /></CommonLayout> </>}></Route>
            <Route path="/promosi/:key/:judul" element={<><CommonLayout><PromosiDetail /></CommonLayout> </>}></Route>
            <Route path="/kebutuhan-pengadaan" element={<><CommonLayout><Pengadaan /></CommonLayout> </>}></Route>
            <Route path="/kebutuhan-pengadaan/:key/:judul" element={<><CommonLayout><PengadaanDetail /></CommonLayout> </>}></Route>
            <Route path="/layanan-dan-pengaduan/:kategori/:subkategori" element={<><CommonLayout><Dukungan /></CommonLayout> </>}></Route>
            <Route path="/layanan-dan-pengaduan/:kategori/:subkategori/produk-hukum/:jenis" element={<><CommonLayout><Produk /></CommonLayout> </>}></Route>
            <Route path="/layanan-dan-pengaduan/:kategori/:subkategori/informasi-pelayanan/:title" element={<><CommonLayout><Pelayanan /></CommonLayout> </>}></Route>
            <Route path="/layanan-dan-pengaduan/:kategori/:subkategori/informasi-pengaduan/:title" element={<><CommonLayout><Pengaduan /></CommonLayout> </>}></Route>
            <Route path="/info/:kategori" element={<><CommonLayout><Info /></CommonLayout> </>}></Route>
            <Route path="/info/:kategori/:title" element={<><CommonLayout><InfoDetail /></CommonLayout> </>}></Route>
            <Route path="/tentang-dpmptsp/:kategori" element={<><CommonLayout><Tentang /></CommonLayout> </>}></Route>
            <Route path="/tentang-dpmptsp/:kategori/:title" element={<><CommonLayout><Pejabat /></CommonLayout> </>}></Route>
            <Route path="/privasi-pengguna" element={<><CommonLayout><Privasi /></CommonLayout> </>}></Route>
            <Route path="/ketentuan-penggunaan" element={<><CommonLayout><Ketentuan /></CommonLayout> </>}></Route>
            <Route path="/peta-situs" element={<><CommonLayout><Sitemap /></CommonLayout> </>}></Route>
            <Route path="/pencarian/:keyword" element={<><CommonLayout><Pencarian /></CommonLayout> </>}></Route>
            <Route path="/survey-kepuasan-masyarakat/:kategori" element={<><CommonLayout><Skm /></CommonLayout> </>}></Route>
            <Route path="*" element={<><CommonLayout><UnderConstruction /></CommonLayout></>}></Route>
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
